export default "__VITE_PUBLIC_ASSET__b608cc70__"